<template>
  <VNotification
    :item="notification"
    name="content-jobs-id-edit"
    @toggle-read="$emit('toggle-read',notification)"
    @close="$emit('close')"
  >
    <template #header>
      <span v-if="notification?.data?.signoffSummary === 'Signed Off'">
        {{ $t(`notification_${notification.type}_signoff`,{ name: actionTakenBy }) }}
      </span>
      <span v-else-if="notification?.data?.signoffSummary === 'Sign Off Removed'">
        {{ $t(`notification_${notification.type}_signoff_removed`,{ name: actionTakenBy }) }}
      </span>
      <span v-else>
        {{ $t(`notification_${notification.type}`,{ name: actionTakenBy }) }}
      </span>
    </template>

    <template #type>
      {{ $t('notification_job_collaboration', { job: notification.data?.jobName }) }}
    </template>

    <template #content>
      <div class="inline">
        <div
          v-if="TYPES_FEEDBACK.includes(notification?.type)"
          class="!text-grey-1 !text-sm"
        >
          <span v-html="displayedComments(notification?.data?.feedback)" />
        </div>
      </div>
    </template>
  </VNotification>
</template>

<script>
import { computed } from 'vue';
import ALL_OPTIONS from '@/constants/options';
// Components
import VNotification from '@/components/templates/notifications/VNotification';
// Utils
import { helpers } from '@/utils/helpers';

export default {
  components: {
    VNotification
  },
  props: {
    notification: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['toggle-read', 'close'],
  setup (props) {
    // Constants
    const TYPES_FEEDBACK = ['JobFeedbackMention'];

    // Computed
    const userAvatar = computed(() => {
      const data = props?.notification?.data ?? {};

      return data.contributorAvatar ? { avatar: { view_path: data.contributorAvatar } } : { firstname: data.contributorName };
    });

    const actionTakenBy = computed(() => props.notification.data?.contributorName || '');

    // Methods
    const displayedComments = (comment) => {
      if (!comment) return '';

      const htmlComment = comment.replace(/@#(\d+),([\w\s]+)#@/g, '<span class="text-blue-1 bg-light-blue-2 rounded-full px-0.75" data-user-id="$1">@$2</span>');
      return helpers.truncateHtml(htmlComment, 310);
    };

    return {
      userAvatar,
      actionTakenBy,
      TYPES_FEEDBACK,
      displayedComments,
      ALL_OPTIONS
    };
  }
};
</script>
